import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as dimensionFilter from '../../plugin'
import type { Plugin } from '../plugin'

/** Restores the applied selection after Current List params are discarded. */
export const discardSelectionsOnParamsDiscarded = store.effects.create(
  <TTypeParams extends Plugin.TypeParams>(
    _feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
    appliedSelectionStorage: Plugin['_appliedSelectionStorage'],
    selectionStorage: dimensionFilter.Plugin['selectionStorage'],
  ) =>
    plugin.collection.plugins.currentListPlugin.feature.actions.discardParams.success
      .observe()
      .pipe(
        rxjsUtils.latestFrom(action => ({
          action: rxjs.of(action),
          appliedSelectionLookup:
            appliedSelectionStorage.selectors.lookup.asObservable,
        })),
        rxjs.map(({ action, appliedSelectionLookup }) =>
          selectionStorage.actions.setLookup
            .from(action)
            .create(appliedSelectionLookup),
        ),
      ),
)
